import React from 'react';
import Lookup from '../componentes/select2';
import { autobind } from 'core-decorators';

@autobind
export default class TipoAcao extends React.Component {
  render() {
    return <Lookup labelKey="descricao" valueKey="id" url="/TipoAcaoEnumLookup" {...this.props} />;
  }
}
